import styles from './Page.module.css';
import { DatePicker, Spin, Empty, Alert  } from 'antd';
import classNames from 'classnames';

import { LoadingOutlined, RightCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
import TelegramIcon from './telegram-logo-png-31.png'; // Припустимо, що ваша іконка Telegram має розширення .svg
import dayjs from 'dayjs';
import 'dayjs/locale/uk';
import locale from 'antd/es/date-picker/locale/uk_UA';
import ScrollToTopButton from '../../components/ScrollToTopButton/component';
import Menu from '../../components/Menu/component';
import { AuthContext } from '../../AuthContext'; // Import AuthContext from the file where it is defined

import React, { useState, useEffect, useContext } from 'react';
import { format, addDays, subDays, getYear } from 'date-fns';
import useMenu from '../../components/Menu/useMenu'; // Шлях до вашого файлу useMenu.js


import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';

const NewsPage = () => {
  const navigate = useNavigate();
  const user = useContext(AuthContext); // Отримання значення _id з контексту
  const { date } = useParams();
  const initialDate = date ? new Date(date) : new Date();
  const [currentDate, setCurrentDate] = useState(initialDate);
  const [news, setNews] = useState([]);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  // const [isOpen, setIsOpen] = useState(false);
  const [userCategories, setUserCategories] = useState([]);
  const [userLocations, setUserLocations] = useState([]);
  const { isOpen, toggleMenu, handleMenuItemClick } = useMenu();


  const getUser = async () => {
    console.log('user: ', user)
    if (user) {
      const dataForRequest = {
        _id: user._id,
      };
      const response = await fetch('/api/user/getUser', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataForRequest),
      });
      let data = await response.json();
      setUserCategories(data.categories);
      if (data.categories.length>0) {
        localStorage.setItem('userCategories', JSON.stringify(data.categories))
      } else {
        localStorage.removeItem('userCategories'); // Очистити локальне сховище, якщо jsonData пустий
      }
      setUserLocations(data.locations);
      if (data.locations.length>0) {
        localStorage.setItem('userLocations', JSON.stringify(data.locations))
      } else {
        localStorage.removeItem('userLocations'); // Очистити локальне сховище, якщо jsonData пустий
      }
    }
  };

  useEffect(() => {
    getUser();
  }, [user]);

  useEffect(() => {
    if (user && user._id) {
      getUser();
    } else{
      let savedCategories = localStorage.getItem('userCategories');
      if (savedCategories) {
        savedCategories = JSON.parse(savedCategories);
        setUserCategories(savedCategories);
      }
      let savedLocations = localStorage.getItem('userLocations');
      if (savedLocations) {
        savedLocations = JSON.parse(savedLocations);
        setUserLocations(savedLocations);
      }
      // setUserLocations(JSON.parse(savedLocations).map(location => location.name));
    }
  }, []);

  useEffect(() => {
    const fetchNewsForDate = async () => {
      try {
        setLoading(true);
        const dataForRequest = {
          date: format(currentDate, 'yyyy-MM-dd'),
          categories: userCategories.map(category => category.name),
          locations: userLocations.map(location => location.name)    
        };
        const response = await fetch('/api/news/getNews', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataForRequest)
        });
        let data = await response.json();
        setNews(data);
        console.log(data);
      } catch (error) {
        console.error('Помилка отримання новин:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNewsForDate();
  }, [currentDate, userCategories, userLocations]); // Залежності оновлюються при зміні поточної дати, категорій та місць


  const goToPreviousDate = () => {
    const previousDate = subDays(currentDate, 1);
    updateUrlParams(previousDate);
    setCurrentDate(previousDate);
  };

  const goToNextDate = () => {
    const nextDate = addDays(currentDate, 1);
    updateUrlParams(nextDate);
    setCurrentDate(nextDate);
  };

  const updateUrlParams = (date) => {
    if (date !== currentDate) {
      navigate(`/news/${format(date, 'yyyy-MM-dd')}`);
      setCurrentDate(date);
    }
  };

  // Отримання поточного року
  const currentYear = getYear(new Date());

  // Формат дати залежно від поточного року
  const dateFormat = 'DD MMMM YYYY';

  const onChange = (date, dateString) => {
    if (date !== null) {
      updateUrlParams(date.toDate());
      setCurrentDate(date.toDate());
    }
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );


  // const toggleMenu = () => {
  //   setIsOpen(!isOpen);
  // };

  // const handleMenuItemClick = () => {
  //   setIsOpen(false);
  // };
  

  return (
    <div className={styles.root}>
      <div className={styles.section_header_date} >
        <ScrollToTopButton />
        <Menu isOpen={isOpen} toggleMenu={toggleMenu} handleMenuItemClick={handleMenuItemClick} />
        <LeftCircleOutlined onClick={goToPreviousDate}  style = { { fontSize : '30px' , border: '#111', color : '#bebebe', margin: '0 10px' } }  />      
        <span>
        <DatePicker value={dayjs(currentDate)} onChange={onChange} locale={locale} format={dateFormat} style={{ width: 'fit-content' }} />
        </span>
        <RightCircleOutlined onClick={goToNextDate}  style = { { fontSize : '30px' , border: '#111', color : '#bebebe', margin: '0 10px' } }  />      
        <span style={{ marginLeft: '10px', marginTop: '10px' }}>
          <a href="https://t.me/ObiznaniNetUA" target="_blank" rel="noopener noreferrer">
            <img src={TelegramIcon} alt="Telegram Logo" width="33" height="33" />
          </a>
        </span>
      </div>
      {/* {(!user || Object.keys(user).length === 0) && (
        <div  className={styles.alertContainer}>
          <Alert
            message={
              <span>
                <Link to="/login"><span className={styles.LoginLink}>Увійдіть </span></Link> щоб перейти з демонстраційного на повний функціонал
                <span className={classNames(styles.menuIcon, 'anticon')}>
                <Menu  isOpen={isOpen} toggleMenu={toggleMenu} handleMenuItemClick={handleMenuItemClick} />
                </span>

              </span>
            }
            type="warning"
            showIcon
          />
        </div>
      )} */}
      {(
        // user && Object.keys(user).length > 0 && 
          (
            userCategories.length === 0 || 
            (userCategories.length === 1 && Object.keys(userCategories[0]).length === 0) || 
            userLocations.length === 0 || 
              (userLocations.length === 1 && Object.keys(userLocations[0]).length === 0)
          ) 
        ) && (
        <div  className={styles.alertContainer}>
          <Alert
            message={
              <span>
                Оберіть потрібні Вам <strong>категорії та локації</strong> в <Link to="/filters"><span className={styles.link}>налаштуваннях</span>  </Link>                <span className={classNames(styles.menuIcon, 'anticon')}>
                <Menu  isOpen={isOpen} toggleMenu={toggleMenu} handleMenuItemClick={handleMenuItemClick} />
                </span>. <br/><strong>Наразі</strong> Вам відображено <strong>лише загальні новини</strong>.
              </span>
            }
            type="warning"
            showIcon
          />
        </div>
      )}
      {loading ? (
        <div className={styles.spinnerContainer}>
          <Spin size="large" indicator={antIcon} />
        </div>
      ) : (
        <>
          {news.length > 0 ? (
            news.map((item, index) => (
              <div key={index} 
              className={classNames(styles.document, { [styles.importance]: item.important })}
              >
                <Link to={item.url} target="_blank">
                  <span className={styles.category}>{item.categories.join(', ')}</span>
                  <span className={styles.location}>, {item.location}</span><br/>
                  <span className={styles.title}>{item.title}</span><br/>
                  <span className={styles.updatedAt}>{item.updated_at ? item.updated_at.substring(11, 16) : ''}</span><br/>
                </Link>
              </div>
            ))
          ) : (
            <div className={styles.emptyContainer}>
              <Empty description="Дані відсутні" />
            </div>
          )}
        </>
      )}
    </div>
  );
};


export default NewsPage;
